<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import {primaryColour} from '../../styles/theme.js';
    import {flip} from 'svelte/animate';
    import {fade} from 'svelte/transition';
    import Panel from '../../Layout/Panel.svelte';
    import RolePanel from './RolePanel.svelte';
    import {elementTabs} from '../tabStore.js';
    import ActivityVersionHeader from './ActivityVersionHeader.svelte';
    import SequenceList from './SequenceList.svelte';
    import emotion from 'emotion/dist/emotion.umd.min.js';
    import SequenceListForm from './SequenceListForm.svelte';
    import {onMount, onDestroy} from 'svelte';
    import {post} from '../../../utils.js';
    //import {calculateColumnWidths} from '../../DataList/utils';
    import {getColumnTemmplate} from '../../DataList/utils.js';
    import ContextMenu from '../../Menu/ContextMenu.svelte';
    import {
        roles, draftElementDetails, elementInstance, selectedSequence, elementDetails,
        loadingElementDetails, activityVersion, currentNewElementButtonId, isEditingName, rolesTotalTime
    } from '../workspacesStore.js';
    import {sgettext} from '../../../i18n.js';
    import Spinner from '../../Spinner.svelte';
    import {WORK_SEQUENCE_API, ACTIVITY_ROLE_API, REORDER_ELEMENT_INSTANCE_API} from '../../../apiUrls.js';
    import {
        selectedListItems, setSelectedElements, isCopy, setSelectedWorkSequences,
        clearSelectedListItems, calculateRoleTotalTime, pasteLocalCopiedElements,
        updateLocalRoles, getWorkSequence, setSelectedRole, saveToLocalStorage, insertRole, insertSequences,
        insertElements, formatSelectedElements, reorderLocalRoles, animateToPosition, getLocalElementInstance,
        formatSelectedSequences, formatSelectedRoles, isDragging
    } from './utils.js';
    import RoleListForm from './RoleListForm.svelte';
    import {dragDropZone} from './actions/dragAndDrop.js';
    import ElementNameRenderer from './ElementNameRenderer.svelte';
    import SequenceHeaderRenderer from './SequenceHeaderRenderer.svelte';
    import SequenceColumnRenderer from './SequenceColumnRenderer.svelte';
    import ReasonColumnRenderer from './ReasonColumnRenderer.svelte';
    import FixColumnRenderer from './FixColumnRenderer.svelte';
    import QualityQuestionsRenderer from './QualityQuestionsRenderer.svelte';


    import ListColumnToggleHeader from './ListColumnToggleHeader.svelte';
    import {setActiveTab} from '../../TabView/TabView.svelte';
    import DurationDisplay from '../../common/DurationDisplay.svelte';

    export let deleteElementInstanceApi = `${PATH_PREFIX}/sw/api/builder/elementinstance/delete/`;
    export let loading = false;
    export let editable = true;
    export let frameWidth;
    export let valid = true;

    $: isEditable = ($activityVersion ? $activityVersion.isEditable : false) && editable;

    const {css} = emotion;

    const dragDropConfig = {
        draggableClass: 'draggable',
        droppableClass: 'droppable',
        droppableZones: {
            role: ['role'],
            sequence: ['sequence', 'role'],
            element: ['element', 'sequence']
        }
    };

    let showMenu = false;
    let activeMenu = null;
    let menuContext = null;
    let currentAction;
    let menuPosition = {};
    let insertAfter = true;
    let originalData = [...$roles];
    let draggedData = [];
    const headerHeight = '108px';
    let style = `height: calc(100% - ${headerHeight})`;

    let columns = {
        name:
            {
                label: "",
                columnRenderer: ElementNameRenderer,
                class: 'shrinkable',
                show: true,
                truncate: true
            },
        travel_time:
            {
                class: "right",
                headerRenderer: SequenceHeaderRenderer,
                columnRenderer: SequenceColumnRenderer,
                iconClass: 'fa5-walking',
                show: true,
                canHide: true,
                width: '65px',
                truncate: true
            },
        total_time:
            {
                class: "right",
                headerRenderer: SequenceHeaderRenderer,
                columnRenderer: SequenceColumnRenderer,
                iconClass: 'fa5-clock',
                show: true,
                canHide: true,
                width: '70px',
                truncate: true
            },
        lowest_maintainable_item:
            {
                label: sgettext('$$LMI$$'),
                show: false,
                canHide: true,
                width: '0.2fr',
                truncate: true
            },
        execution_condition:
            {
                label: sgettext('$$EXECUTION_CONDITION$$'),
                show: false,
                canHide: true,
                width: '0.3fr',
                truncate: true
            },
        tags:{
            label: sgettext('$$TAGS$$'),
            show: false,
            canHide: true,
            width: '0.2fr',
            truncate: true
        },
        quality_questions_count:{
            label: sgettext('$$QUALITY_QUESTIONS$$'),
            columnRenderer: QualityQuestionsRenderer,
            show: false,
            canHide: true,
            width: '0.2fr',
            truncate: true
        },
        element_id:{
                label: sgettext('$$ELEMENT$$'),
                show: false,
                canHide: true,
                width: '0.2fr',
                truncate: true
            },
        invalid_reasons:
            {
                label: sgettext('$$INVALID_REASONS$$'),
                show: false,
            },
         reason:
            {
                label: sgettext('$$REASON$$'),
                columnRenderer: ReasonColumnRenderer,
                show: false,
                canHide: true,
                truncate: true,
                width: '0.3fr',
            },
         fix:
            {
                label: sgettext('$$FIX$$'),
                columnRenderer: FixColumnRenderer,
                class: "right",
                show: false,
                canHide: true,
                width: "40px",
            },
    }

    // ensure the fix column is always showing if the reason column is
    // particularly on full page reload
    $: if (columns && columns.reason.show && isEditable) {
        columns.fix.show = true;
    }

    $: {
        if($activityVersion?.activity_governance_type === 'APM Governed'){
            for (let options of displayOptions) {
                if(options.id == 'lowest_maintainable_item'){
                    options.selected=true
                }
                else{
                    options.selected=false
                }
            }
            columns.travel_time.show=false
            columns.total_time.show=false
            columns.lowest_maintainable_item.show=true
        }
    }

    $: allColumnsHidden = Object.values(columns).filter(col => col.canHide && col.show).length === 0;

    $: headerCss = getHeaderCSS(columns, frameWidth);

    let contextMenu = {
        role: [
            [
                {
                    key: 'cut',
                    label: sgettext('$$CUT$$'),
                    action: cutListItems
                },
                {
                    key: 'paste',
                    label: sgettext('$$PASTE$$'),
                    action: pasteRole,
                    disabled: true
                },
                {
                    key: 'delete',
                    label: sgettext('$$DELETE_1$$'),
                    action: deleteRole
                }
            ],
        ],
        workSequence: [
            [
                {
                    key: 'cut',
                    label: sgettext('$$CUT$$'),
                    action: cutListItems
                },
                {
                    key: 'copy',
                    label: sgettext('$$COPY$$'),
                    action: copyListItems
                },
                {
                    key: 'paste',
                    label: sgettext('$$PASTE$$'),
                    disabled: true,
                    action: pasteSequences
                },
                {
                    key: 'duplicate',
                    label: sgettext('$$DUPLICATE$$'),
                    action: () => onAction('Duplicate'),
                    hide: true
                }
            ],
            [
                {
                    key: 'remove',
                    label: sgettext('$$DELETE_1$$'),
                    action: deleteWorkSequence
                }
            ]
        ],
        elementInstance: [
            [
                {
                    key: 'cut',
                    label: sgettext('$$CUT$$'),
                    action: cutListItems
                },
                {
                    key: 'copy',
                    label: sgettext('$$COPY$$'),
                    action: copyListItems
                },
                {
                    key: 'paste',
                    label: sgettext('$$PASTE$$'),
                    action: pasteElements,
                    disabled: true,
                }
            ],
            [
                {
                    key: 'remove',
                    label: sgettext('$$REMOVE$$'),
                    action: deleteElementInstance,
                    disabled: false,
                }
            ]
        ]
    }

    let displayOptions = [
        {
            id: 'time',
            name: sgettext('$$TIME$$'),
            faIcon: {
                classes: 'fas fa5-clock',
                style: 'color: #1B67B1;'
            },
            selected: false
        },
        {
            id: 'lowest_maintainable_item',
            name: sgettext('$$LOWEST_MAINTAINABLE_ITEM$$'),
            faIcon: {classes: 'far fa5-check-circle', style: 'color: #454545;'},
            selected: false
        },
        {
            id: 'execution_condition',
            name: sgettext('$$EXECUTION_CONDITION$$'),
            faIcon: {classes: 'far fa5-check-circle', style: 'color: #454545;'},
            selected: false
        },
        {
            id: 'tags',
            name: sgettext('$$TAGS$$'),
            faIcon: {classes: 'fa fa-tags', style: 'color: #454545;'},
            selected: false

        },
        {
            id: 'quality_questions_count',
            name: sgettext('$$QUALITY_QUESTIONS$$'),
            faIcon: false,
            selected: false

        },
        {
            id: 'element_id',
            name: sgettext('$$ELEMENT$$'),
            faIcon: {classes: 'far fa5-check-circle', style: 'color: #454545;'},
            selected: false
        },
        {
            id: 'invalid_reasons',
            name: sgettext('$$INVALID_REASONS$$'),
            faIcon: {classes: 'fa fa-exclamation-circle text-danger'},
            selected: false

        },
    ];

    function getHeaderCSS(headerColumns, frameWidth) {
        return css`
            display: grid;
            grid-template-columns: 25px 25px 25px ${getColumnTemmplate(headerColumns)} 20px;
            grid-auto-rows: fit-content(min-content, max-content);
        `;
    }

    function handleKeyUp(event) {
        event.stopPropagation();
        if (editable) {
            if (event.key === "Escape") {
                roles.set(clearSelectedListItems($roles));
                selectedListItems.set([]);
                saveToLocalStorage('selectedListItems', JSON.stringify($selectedListItems));
                resetMenuMode();
            }
        }
    }

    function setMenuPasteMode() {
        if (activeMenu) {
            activeMenu.forEach(n => {
                n.forEach(i => {
                    if (i.key !== 'paste') {
                        i.disabled = true;
                    } else {
                        delete i.disabled;
                    }
                });
            });

            activeMenu = [...activeMenu];
        }
    }


    function handleCopyOrCut(handleCopy) {
        setMenuPasteMode();

        if ($selectedListItems.length === 0) {
            if (menuContext.entityType === 'element') {
                setSelectedElements($roles, [menuContext.entity], menuContext.entity.id);
            } else if (menuContext.entityType === 'sequence') {
                // sequence
                setSelectedWorkSequences($roles, [menuContext.entity], menuContext.entity.id);
            } else if (menuContext.entityType === 'role') {
                setSelectedRole($roles, menuContext.entity.id);
            }
            selectedListItems.set([menuContext.entity]);
        }
        if (handleCopy) {
            $selectedListItems.forEach(selected => selected.copied = true);
        } else {
            $selectedListItems.forEach(selected => selected.cut = true);
        }
        roles.set([...$roles]);
        isCopy.set(handleCopy);
    }


    function cutListItems() {
        currentAction = 'cut';
        handleCopyOrCut(false);
    }

    function copyListItems() {
        currentAction = 'copy';
        // true to indicate copy
        handleCopyOrCut(true);
    }

    function resetMenuMode() {
        if (activeMenu) {
            activeMenu.forEach(n => {
                n.forEach(i => {
                    if (i.key !== 'paste') {
                        delete i.disabled;
                    } else {
                        i.disabled = true;
                    }
                });
            });

            activeMenu = [...activeMenu];
        }
        currentAction = null;
    }

    async function updateListItems(roleId, seqId, elementInstanceId, schematic_id, isAfter, callback = () => {
    }) {
        if ($selectedListItems.length && roleId) {
            $selectedListItems.forEach((s, i) => s.step = i);
            const ws = getWorkSequence($roles, roleId, seqId);
            const api = $selectedListItems[0].hasOwnProperty('element_id') ? REORDER_ELEMENT_INSTANCE_API : WORK_SEQUENCE_API;
            const data = {
                selected: $selectedListItems.map(s => ({
                    role_id: s.role_id,
                    seq_id: s.hasOwnProperty('work_sequence_id') ? s.work_sequence_id : s.id,
                    item_id: s.id
                })),
                target: {
                    role_id: roleId,
                    schematic_id: schematic_id,
                    sequence_id: seqId,
                    element_instance_id: elementInstanceId,
                    is_after: isAfter,
                    activity_version_id: $activityVersion.id
                },
                is_copy: $isCopy,
            };
            try {
                const resp = await post(`${api}${'paste'}/`, data);
                if (resp.ok) {
                    const json = await resp.json();
                    const updated = updateLocalRoles($roles, json);
                    roles.set(updated);
                    rolesTotalTime.set(calculateRoleTotalTime(updated));
                } else {
                    callback();
                }
            } catch {
                callback();
            }

            resetMenuMode();
            selectedListItems.set([]);
        }

    }

    async function pasteRole(event, menuItem) {
        currentAction = menuItem.key;
        const payload = {
            selected: $selectedListItems.map(e => e.id),
            target: {
                role_id: menuContext.entity.id,
                is_after: insertAfter
            },
            is_copy: $isCopy,
            activity_version_id: $activityVersion.id
        };

        if ($selectedListItems[0].hasOwnProperty('worksequences')) {
            await updateRoleMoved(payload);
        } else if ($selectedListItems[0].hasOwnProperty('element_instances')) {
            await updateListItems(menuContext.entity.id, 0, null, 0, true);
        }

        resetMenuMode();
    }

    async function deleteRole() {
        const role = $selectedListItems.length ? $selectedListItems[0] : null;
        if (role) {
            const url = `${ACTIVITY_ROLE_API}${role.id}/delete_role/`;
            const resp = await post(url, null);

            if (resp.ok) {
                roles.set($roles.filter(r => r.id !== role.id));
                selectedListItems.set([]);
            }
        }

    }

    async function pasteSequences() {
        let target = menuContext.entity.id;
        await updateListItems(menuContext.entity.role_id, target, 0, 0, true);
    }

    function onAction() {

    }

    async function deleteWorkSequence() {
        if ($selectedListItems.length) {
            const url = `${WORK_SEQUENCE_API}remove/`;
            const payload = $selectedListItems.map(s => ({
                role_id: s.role_id,
                item_id: s.id
            }));
            const resp = await post(url, payload);

            if (resp.ok) {
                const json = await resp.json();

                roles.set(updateLocalRoles($roles, json));
                rolesTotalTime.set(calculateRoleTotalTime($roles));
                selectedListItems.set([]);
            }
        }
    }

    async function pasteElements(event) {
        // TODO: allow paste before and paste after
        await updateListItems(menuContext.entity.role_id, menuContext.entity.work_sequence_id,
            menuContext.entity.id, 0, true);
    }

    async function deleteElementInstance() {
        if ($selectedListItems.length) {
            const payload = $selectedListItems.map(s => ({
                'role_id': s.role_id,
                'seq_id': s.work_sequence_id,
                'item_id': s.id
            }));
            const response = await post(deleteElementInstanceApi, payload);

            if (response.ok) {
                const json = await response.json();

                roles.set(updateLocalRoles($roles, json));
                selectedListItems.set([]);

                elementInstance.set(null);
                elementDetails.set(null);

                elementTabs.set(setActiveTab('view', $elementTabs));

            }
        }
    }


    function toggleContextMenu(event) {
        if (editable) {
            let disableDeleteRole = false;
            menuContext = {entityType: event.detail.entityType, entity: event.detail.entity};

            showMenu = false;
            menuPosition = {
                x: event.detail.event.clientX,
                y: event.detail.event.clientY
            };

            if (event.detail.entityType === 'sequence') {
                activeMenu = contextMenu.workSequence;
            } else if (event.detail.entityType === 'element') {
                activeMenu = contextMenu.elementInstance;
            } else if (event.detail.entityType === 'role') {
                activeMenu = contextMenu.role;
                if (currentAction != 'cut' && currentAction != 'copy') {
                    selectedListItems.set([event.detail.entity]);
                }

                disableDeleteRole = event.detail.entity.worksequences.length || $selectedListItems.length > 1
                    || currentAction;
            }

            if (currentAction === 'cut' || currentAction === 'copy') {
                setMenuPasteMode();
            } else if (!currentAction) {
                resetMenuMode();
                if (disableDeleteRole) {
                    updateActiveMenu('delete', 'disabled', true);
                }
            }
            
            if (event.detail.entityType === 'element') {
                disableOptionsAPM(activeMenu);
                disableOptionsAIES(activeMenu)
            }
            showMenu = true;
        }
    }

    async function disableOptionsAPM(activeMenu) {
        if (activeMenu && menuContext.entity.action_id !== null && menuContext.entity.type === 'QUALITY' && $activityVersion.activity_governance_type === 'APM Governed') {
            updateActiveMenu('remove', 'disabled', true);
            updateActiveMenu('cut', 'disabled', true);
            updateActiveMenu('copy', 'disabled', true);

        } else {
            updateActiveMenu('remove', 'disabled', false);
        }
    }

    async function disableOptionsAIES(activeMenu) {
        if (activeMenu && menuContext.entity.inspection_location_class_id) {
            updateActiveMenu('copy', 'disabled', true);

        } else {
            updateActiveMenu('remove', 'disabled', false);
        }
    }

    function updateActiveMenu(key, attribute, value) {
        for (let i = 0; i < activeMenu.length; i++) {
            const found = activeMenu[i].find(e => e.key === key);
            if (found) {
                if (value) {
                    found[attribute] = value;
                } else {
                    delete found[attribute];
                }
                break;
            }
        }

        activeMenu = [...activeMenu];
    }

    async function getIssuesCount() {
        const eevId = $elementDetails ? $elementDetails.eevId : 0;

        if (eevId) {
            const issuesResponse = await get(`${PATH_PREFIX}/sw/api/elements_database/element_version/${eevId}/element-issues/`);
            if (issuesResponse.ok) {
                const issues = await issuesResponse.json();
                const activeTab = $elementTabs.find(t => t.key === 'issues');
                const numOpenIssues = issues.filter(x => x.status === 'OPEN').length;
                activeTab.label = `${sgettext('$$IMPROVEMENTS$$')} (${numOpenIssues})`;
                elementTabs.set([...$elementTabs]);
            }
        }
    }

    function handlePositionChange(event) {
        if (event.detail.dragItemType === 'role') {
            updateDraggedRoles(event.detail);
        } else if (event.detail.dragItemType === 'sequence') {
            updateDraggedSequences(event.detail);
        } else if (event.detail.dragItemType === 'element') {
            updateDraggedElements(event.detail);
        }
    }

    function updateDraggedSequences(detail) {
        if (detail?.draggedData) {
            const updatedRoles = [...$roles];
            insertSequences(
                updatedRoles,
                draggedData,
                detail.dropZoneItemId,
                detail.dropZoneRoleId,
                detail.isAfter
            );
            roles.set(updatedRoles);
        }
    }

    function updateDraggedElements(detail) {
        if (detail?.draggedData) {
            const updatedRoles = [...$roles];
            insertElements(
                updatedRoles,
                draggedData,
                detail.dropZoneItemId,
                detail.dropZoneSeqId,
                detail.dropZoneRoleId,
                detail.isAfter
            );
            roles.set(updatedRoles);
        }
    }

    function updateDraggedRoles(detail) {
        if (detail?.draggedData) {
            const updatedRoles = [...$roles];
            if (insertRole(
                updatedRoles,
                draggedData,
                detail.dropZoneItemId,
                detail.isAfter)) {
                roles.set(updatedRoles);
            }
        }
    }

    async function updateRoleMoved(payload) {
        const url = `${ACTIVITY_ROLE_API}paste/`;

        const resp = await post(url, payload);

        if (resp.ok) {
            const json = await resp.json();
            roles.set(reorderLocalRoles($roles, json));
            selectedListItems.set([]);
        }
    }

    async function handleDrop(event) {
        isDragging.set(false);
        const update = [...$roles];
        if (editable && event.detail.draggedData) {
            isCopy.set(false);
            animateListItemToPostion(event.detail.dragItemType, event.detail.draggedData[0].id);
            if (event.detail.dragItemType === 'role') {
                const payload = {
                    selected: event.detail.draggedData.map(m => m.id),
                    target: {
                        role_id: event.detail.dropZoneItemId,
                        is_after: event.detail.isAfter
                    },
                    is_copy: $isCopy,
                    activity_version_id: $activityVersion.id
                };
                formatSelectedRoles(update, event.detail.draggedData, {shadow: false});
                await updateRoleMoved(payload);
            } else if (event.detail.dragItemType === 'sequence') {
                let target = null;
                if (event.detail.dropZoneItemType === 'sequence') {
                    target = event.detail.dropZoneItemId;
                }
                formatSelectedSequences(update, event.detail.draggedData, {shadow: false});
                await updateListItems(
                    event.detail.dropZoneRoleId,
                    target,
                    null,
                    0,
                    event.detail.isAfter,
                    revertIfFailed
                );

            } else if (event.detail.dragItemType === 'element') {
                let target = null;
                let seqId = event.detail.dropZoneItemId;
                if (event.detail.dropZoneItemType === 'element') {
                    target = event.detail.dropZoneItemId;
                    seqId = event.detail.dropZoneSeqId;
                }else if (
                    event.detail.dropZoneItemType === 'sequence' 
                    && !event.detail.isAfter 
                    && event.detail.dropZoneSeqId === seqId
                ){
                    /* Edge case when and element is moved to the first position 
                    but is located on the title of the sequence instead of the first element */
                    try {
                        const firstElem = originalData.find(
                            role => role.id === event.detail.dropZoneRoleId
                        ).worksequences.find(ws => ws.id === seqId).element_instances[0];
                        target = firstElem.id || target;
                    } catch (error) {
                        console.log(error);
                    }
                }
                formatSelectedElements(update, event.detail.draggedData, {shadow: false}, event.detail.dropZoneRoleId, event.detail.dropZoneSeqId);

                if(event.detail.dropZoneRoleId)
                await updateListItems(
                    event.detail.dropZoneRoleId,
                    seqId,
                    target,
                    0,
                    event.detail.isAfter,
                    revertIfFailed
                );

            }
            roles.set(update);
        }
    }

    function animateListItemToPostion(itemType, itemId) {
        let draggedElement = document.getElementById('draggedElement');
        if (draggedElement) {
            const destination = document.getElementById(`${itemType}${itemId}`);
            window.requestAnimationFrame(() => {
                animateToPosition(
                    draggedElement,
                    destination,
                    () => {
                        draggedElement.remove();
                        draggedElement = undefined;
                    },
                    300);
            });

        }
    }

    function revertIfFailed() {
        roles.set(originalData);
    }

    function handleGrabbed(event) {}

    function handleDragStart(event) {
        draggedData = [...event.detail.draggedData];
        isDragging.set(true);
        originalData = structuredClone($roles); // Unlinked deep copy of data before it changes
        const update = [...$roles];

        if (event.detail.dragItemType === 'element') {
            formatSelectedElements(update, $selectedListItems, {shadow: true});
        } else if (event.detail.dragItemType === 'sequence') {
            formatSelectedSequences(update, $selectedListItems, {shadow: true});
        } else if (event.detail.dragItemType === 'role') {
            formatSelectedRoles(update, $selectedListItems, {shadow: true});
        }
        roles.set(update);
    }

    function toggleColumnDisplay(selectedColumns) {
        selectedColumns.forEach(c => {
            if (c.id === 'time') {
                columns.travel_time.show = c.selected;
                columns.total_time.show = c.selected;
            } else if (c.id === 'invalid_reasons' && isEditable) {
                columns.reason.show = c.selected;
                columns.fix.show = c.selected;
            } else if (c.id === 'invalid_reasons' && !isEditable) {
                columns.reason.show = c.selected;
                columns.fix.show = false;
            } else if (c.id === 'tags') {
                columns.tags.show = c.selected;
            } else if (c.id === 'quality_questions_count') {
                columns.quality_questions_count.show = c.selected;
            }  else {
                columns[c.id].show = c.selected;
            }
        });

        columns = {...columns};
    }

    onMount(() => {
        document.addEventListener('keyup', handleKeyUp);
    });

    onDestroy(() => {
        document.removeEventListener('keyup', handleKeyUp);
    });



</script>

<style>  
    .header {
        font-weight: bold;
        background-color: #dee2e6;
    }

    .header > div {
        padding: 3px 8px;
    }

    :global(.shrinkable) {
        min-width: 0;
    }

    .header > div, .header > div div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .roleHeader {
        text-align: center;
    }

    .cell {
        /* border: 1px solid red; */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>

<Panel title={sgettext('$$SEQUENCE_LIST$$')} collapsible={false} padded={false} headerColour={primaryColour} hideOverflowX={true} {style}>

    <div slot="headerExtra">
        <ListColumnToggleHeader {displayOptions} {toggleColumnDisplay} persistKey='workspace-role-list-display-options'/>
        <ActivityVersionHeader {valid}/>
    </div>

    <div
        class="grid"
        slot="body"
        on:keyup={handleKeyUp}
        use:dragDropZone={dragDropConfig}
        on:grabbed={handleGrabbed}
        on:positionChange={handlePositionChange}
        on:dropped={handleDrop}
        on:dragStart={handleDragStart}
    >
        {#if loading}
            <div class="spinner-div">
                <Spinner size="large"/>
            </div>
        {:else}

            {#each $roles as role (role.id)}
                <div animate:flip={{duration: 300}}>
                    <RolePanel
                        {role}
                        {editable}
                        on:showMenu={toggleContextMenu}
                    >
                        <svelte:fragment slot="subHeader">
                            {#if !allColumnsHidden}
                                <div class="header ignore {headerCss}">
                                    <div></div>
                                    <div></div>
                                    <div></div>

                                    {#each Object.keys(columns) as col}
                                        {#if columns[col].show}
                                            <div class="cell">
                                                {#if columns[col].headerRenderer}
                                                    <svelte:component
                                                        this={columns[col].headerRenderer}
                                                        col={columns[col]}
                                                        label="{$rolesTotalTime[role.id] ? $rolesTotalTime[role.id][col] : ''}"
                                                    />
                                                {:else}
                                                    <div>{columns[col].label}</div>
                                                {/if}
                                            </div>
                                        {/if}
                                    {/each}
                                    {#if allColumnsHidden}
                                        <div class="cell" />
                                    {/if}
                                    <div class="cell" />
                                </div>
                            {/if}
                        </svelte:fragment>
                        <span slot="headerExtra">
                            {#if columns["total_time"].show}
                                <DurationDisplay seconds={role.cycle_time} additionalClasses="font-weight-bold"/>
                            {/if}
                        </span>
                        <SequenceList {role} on:showMenu={toggleContextMenu} {editable}
                                      workSequences="{role.worksequences}" {currentAction}
                                      {columns} on:resetMenu={resetMenuMode} on:selected={() => showMenu = false}
                                      frameWidth={frameWidth}/>
                        {#if editable}
                            <SequenceListForm context="{role}" actionApi="{WORK_SEQUENCE_API}"/>
                        {/if}

                    </RolePanel>
                </div>
            {/each}

            {#if editable}
                <RoleListForm actionApi={ACTIVITY_ROLE_API}/>
            {/if}
        {/if}

    </div>
</Panel>

{#if showMenu}
    <ContextMenu
        bind:showMenu={showMenu}
        {currentAction}
        items={activeMenu}
        position={menuPosition}
    />
{/if}
